module.exports = __webpack_public_path__ + "static/media/background.993d94a0.png";